import { useLocation, useNavigate } from "react-router-dom";

const ROUTES = {
  home: "/",
  lab: "/lab",
  staffing: "/staffing",
  it: "/it",
  valuation: "/valuation",
  blog: "/blog",
  careers: "/careers",
  contact: "/contact",
};

const PAGE_BY_PATH = Object.fromEntries(Object.entries(ROUTES).map(([k, v]) => [v, k]));

export function useGo() {
  const navigate = useNavigate();
  return (id) => navigate(ROUTES[id] || "/");
}

export function useCurrentPage() {
  const { pathname } = useLocation();
  return PAGE_BY_PATH[pathname] || "home";
}
